import {ReactNode} from 'react'
import {StyledComponentCard, StyledComponentTitle, StyledImage} from './style'

export const ComponentCard = ({
    title,
    image,
    description
}: {
    title: string
    image: ReactNode
    description: string | ReactNode
}) => {
    const isPDF = new URLSearchParams(location.search).get('pdf') === 'true'

    return (
        <StyledComponentCard direction={'column'} gap={4} isPDF={isPDF}>
            <StyledImage>{image}</StyledImage>
            <StyledComponentTitle>{title}</StyledComponentTitle>
            <p className={'description'}>{description}</p>
        </StyledComponentCard>
    )
}
ComponentCard.displayName = 'ComponentCard'
